module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"table report-table\">\n	<div class=\"thead\">\n		")
    ;  for (var i in columns) if(columns.hasOwnProperty(i)) { var col = columns[i]; 
    ; __append("\n		<div ")
    ; __append(escapeFn( col.width ? 'style="min-width: ' + col.width + 'px"' : '' ))
    ; __append(" >")
    ; __append(escapeFn( col.title ))
    ; __append("</div>\n		")
    ;  } 
    ; __append("\n	</div>\n</div>\n\n<div class=\"wh100\">\n	<div class=\"cell__abs_container\">\n		<div class=\"cell__abs overflow-y__auto\">\n			<div>\n				<div class=\"table report-table\" name=\"table\">\n					")
    ;  for (var i in data) if(data.hasOwnProperty(i)) { var el = data[i]; 
    ; __append("\n					<div>\n						")
    ;  for (var i in columns) if(columns.hasOwnProperty(i)) { var col = columns[i]; 
    ; __append("\n						<div>\n							")
    ;  var value = (typeof col.value == 'function') ? col.value(el) : ((typeof el[col.value] == 'undefined') ? '-' : el[col.value]) 
    ; __append("\n							")
    ; __append(escapeFn( value ))
    ; __append("\n						</div>\n						")
    ;  } 
    ; __append("\n					</div>\n					")
    ;  } 
    ; __append("\n				</div>\n			</div>\n		</div>\n	</div>\n</div>")
  }
  return __output.join("");

}